<template>
  <div>
    <Modal v-model="show" title="销毁集群" width="600">
      <Alert show-icon type="error" v-if="errorMsg">{{ errorMsg }}</Alert>
      同时销毁集群下的所有容器
      <RadioGroup v-model="is_delete_container">
        <Radio label="yes" border>是</Radio>
        <Radio label="no" border>否</Radio>
      </RadioGroup>
      <div slot="footer">
        <Button type="error" @click="submit" :loading="submitting">销毁</Button>
        <Button @click="show = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { deleteCluster } from '@/api/container/cluster'

export default {
  name: 'delete-cluster',
  data () {
    return {
      show: false,
      cluster_id: '',
      is_delete_container: 'no',
      submitting: false,
      errorMsg: null
    }
  },
  methods: {
    showModal (clusterId) {
      this.cluster_id = clusterId
      this.show = true
    },
    submit () {
      let reqData = {
        is_delete_container: this.is_delete_container === 'yes'
      }
      this.submitting = true
      this.errorMsg = null
      deleteCluster(this.cluster_id, reqData).then(res => {
        this.$Notice.success({title: '操作成功'})
        this.$emit('callback')
        this.show = false
        this.submitting = false
      }).catch(res => {
        this.submitting = false
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
          this.errorMsg = res.response.data
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
